module.exports = __webpack_public_path__ + "img/rejected-semipublic.e8546249.svg";